import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useIsMobile } from "@/hooks/use-mobile";

export const RestaurantSearch = ({ onSearch }: { onSearch: (query: string) => void }) => {
  const isMobile = useIsMobile();

  return (
    <div className="w-full">
      <div className="relative">
        <Input
          type="text"
          placeholder="Search venues..."
          className="w-full pl-8 h-9 bg-accent/50 border-transparent focus:border-primary/20 text-primary placeholder:text-primary/60 text-sm"
          onChange={(e) => onSearch(e.target.value)}
        />
        <Search className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-primary/60" />
      </div>
    </div>
  );
};